export enum AddonsInsuranceType {
  STANDARD = 'STANDARD',
  EXTRA = 'EXTRA',
}

// The API caps `extraDeliveryInfo` at 2000 characters, and we merge up to two
// user-provided texts into it, so each input is limited to half of that.
export const EXTRA_DELIVERY_INFO_MAX_LENGTH = 2000
export const EXTRA_DELIVERY_INFO_INPUT_MAX_LENGTH = 1000
